import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';


export class SkyListToolbarDemoComponent {
  public items = Observable.of([
    { id: '1', column1: 101, column2: 'Apple', column3: 'Anne eats apples' },
    { id: '2', column1: 202, column2: 'Banana', column3: 'Ben eats bananas' },
    { id: '3', column1: 303, column2: 'Pear', column3: 'Patty eats pears' },
    { id: '4', column1: 404, column2: 'Grape', column3: 'George eats grapes' },
    { id: '5', column1: 505, column2: 'Banana', column3: 'Becky eats bananas' },
    { id: '6', column1: 606, column2: 'Lemon', column3: 'Larry eats lemons' },
    { id: '7', column1: 707, column2: 'Strawberry', column3: 'Sally eats strawberries' }
  ]);
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-list-toolbar-demo',
  template: `
<sky-list [data]="items" [defaultView]="grid">
  <sky-list-toolbar>
    <sky-list-secondary-actions>
      <sky-list-secondary-action>
        <button type="button">
          Option
        </button>
      </sky-list-secondary-action>
    </sky-list-secondary-actions>
    <sky-list-toolbar-sort
      label="Fruit name (A - Z)"
      field="column2"
      [descending]="false"
      type="string"
    >
    </sky-list-toolbar-sort>
    <sky-list-toolbar-sort
      label="Fruit name (Z - A)"
      field="column2"
      [descending]="true"
      type="string"
    >
    </sky-list-toolbar-sort>
  </sky-list-toolbar>

  <sky-list-view-grid fit="scroll" #grid>
    <sky-grid-column
      field="column1"
      heading="Column1"
      [isSortable]="false">
    </sky-grid-column>
    <sky-grid-column field="column2" heading="Column2">
    </sky-grid-column>
  </sky-list-view-grid>
 </sky-list>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
